import Tone from 'tone';

const MAX_CACHE_SIZE = 50;
class LFOChainFactory {
    constructor() {
        this.chains = [];
    }

    useChain(parameter, engine) {
        let chain = undefined;
        if (this.chains.length > 0 && !engine.isOffline) {
            let popped = this.chains.pop();
            chain = popped;
        } else {
            chain =
                [
                    new Tone.Normalize(-100, 100),
                    new Tone.Scale(parameter.min, parameter.max),
                    new Tone.Gain(1)
                ];
        }
        chain[1].min = parameter.min;
        chain[1].max = parameter.max;
        return chain;
    }

    disposeChain(chain) { chain.forEach(c => c.dispose()) }

    releaseChain(chain, engine) {
        if (engine.isOffline) {
            this.disposeChain(chain);
            return;
        }
        if (this.chains.length >= MAX_CACHE_SIZE) {
            let chain = this.chains[0];
            this.disposeChain(chain);
            this.chains = this.chains.slice(1);
        }
        this.chains.push(chain);
    }
}

export const chainFactory = new LFOChainFactory();
